import { useState } from 'react';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import FixedBtnWrapper from '../ui/FixBtnWrapper';
import useGetUserProfileInfo from '@/hooks/auth/useGetUserProfileInfo';
import MobileDeposit from './MobileDeposit';
export default function NewUserDeposit() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    firstName
  } = useGetUserProfileInfo();
  return <div className='overflow-hidden h-[80vh]  ' data-sentry-component="NewUserDeposit" data-sentry-source-file="NewUserDeposit.tsx">
    
      <div className='w-full p-2 flex flex-col justify-center relative deposit-box    '>
        <div className='ta-c flex-grow w-full  rounded-md px-2 x '>
          <div className='my-8 '>
            <Image src={'/static/genius.png'} alt='genius_logo' width={100} height={100} className='w-[36px] h-[36px]' data-sentry-element="Image" data-sentry-source-file="NewUserDeposit.tsx" />
          </div>
          <div className='text-[16px] tracking-tighter text-genius-gradient mb-6 font-normal'>
            Welcome {firstName},
          </div>
          <div className='text-[24px] tracking-tighter text-genius-gradient'>
            Deposit to Continue
          </div>
          <MobileDeposit isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} data-sentry-element="MobileDeposit" data-sentry-source-file="NewUserDeposit.tsx" />

          <FixedBtnWrapper className='bg-transparent left-0 px-4' data-sentry-element="FixedBtnWrapper" data-sentry-source-file="NewUserDeposit.tsx">
            <Button onClick={() => {
            setIsModalOpen(true);
          }} className='h-[56px] text-[14px]  rounded-full bg-genius-pink md:hover:bg-genius-pink w-full mb-8' data-sentry-element="Button" data-sentry-source-file="NewUserDeposit.tsx">
              Deposit Cash or Crypto
            </Button>
          </FixedBtnWrapper>
        </div>
      </div>
    
    </div>;
}